import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Brain } from "@phosphor-icons/react";
import { toast } from "sonner";

const NAMES = { logistic_regression: "Logistic Regression", tree_ensemble: "Tree-Based Ensemble", random_forest: "Random Forest", gradient_boosting: "Gradient Boosting", deep_neural_network: "Deep Neural Network", support_vector_machine: "Support Vector Machine", k_nearest_neighbor: "K-Nearest Neighbor" };

export default function CreditModelCard() {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/credit-model").then((r) => setM(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const retrain = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/credit-model/retrain"); toast.success(`Model ${data.version} trained on ${data.trained_on} outcomes`); load(); }
    catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  if (!m) return null;
  return (
    <div className="card mt-8" data-testid="credit-model-card">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
        <h2 className="font-display text-xl font-medium flex items-center gap-2"><Brain size={18} weight="fill" className="text-[#0A3622]" /> Credit scoring ensemble</h2>
        <span className="badge badge-info" data-testid="credit-model-version">{m.version} · {m.kind === "trained" ? "trained on real outcomes" : "rule-based proxies"}</span>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2 text-xs mb-4">
        {Object.entries(m.weights).map(([k, w]) => (
          <div key={k} className="flex justify-between rounded-lg border border-[#E5E3DB] px-3 py-2"><span>{NAMES[k] || k}</span><span className="font-mono">{(w * 100).toFixed(0)}%</span></div>
        ))}
      </div>
      <p className="text-sm text-[#4F5D4F]" data-testid="credit-model-data">
        {m.scored_applications} applications scored · {m.labelled_good} repaid · {m.labelled_default} defaulted.
        {m.ready_to_retrain ? " Enough outcomes to retrain." : ` Retraining unlocks at ${m.min_labelled} known outcomes with at least ${m.min_per_class} of each.`}
      </p>
      <button onClick={retrain} disabled={!m.ready_to_retrain || busy} className="btn-outline mt-4 text-sm disabled:opacity-50" data-testid="credit-model-retrain">
        {busy ? "Training…" : "Retrain on real repayment data"}
      </button>
    </div>
  );
}
